import React, { useState } from 'react';
import { Card, Col, Row, Skeleton, Space, Statistic, Typography } from 'antd';
import dayjs from 'dayjs';
import { DateRangeFilter, DateRange, defaultDateRange } from '@shared/components/DateRangeFilter';
import { LineChartCard } from '@shared/components/charts/LineChartCard';
import { useAnalyticsLoyalty } from '@shared/api/hooks/useAnalyticsLoyalty';

export function LoyaltyPage(): React.ReactElement {
  const [range, setRange] = useState<DateRange>(defaultDateRange());
  const { data, isLoading } = useAnalyticsLoyalty(range);

  const daily = (data?.daily ?? []).map((r) => ({ ...r, date: dayjs(r.date).format('DD/MM') }));

  return (
    <div style={{ padding: 24 }}>
      <Space style={{ width: '100%', justifyContent: 'space-between', marginBottom: 16 }}>
        <div>
          <Typography.Title level={3} style={{ margin: 0, fontStyle: 'italic' }}>
            Loyalty
          </Typography.Title>
          <Typography.Text type="secondary">Scontrini caricati dai tifosi</Typography.Text>
        </div>
        <DateRangeFilter value={range} onChange={setRange} />
      </Space>

      {isLoading ? (
        <Skeleton active />
      ) : (
        <>
          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            <Col xs={12} sm={6}>
              <Card>
                <Statistic title="Scontrini validi / non validi" value={`${data?.validCount ?? 0} / ${data?.invalidCount ?? 0}`} />
                {((data?.inReviewCount ?? 0) > 0 || (data?.pendingCount ?? 0) > 0) && (
                  <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                    In revisione: {data?.inReviewCount ?? 0} · In attesa: {data?.pendingCount ?? 0}
                  </Typography.Text>
                )}
              </Card>
            </Col>
            <Col xs={12} sm={6}>
              <Card>
                <Statistic
                  title="Utente più attivo"
                  value={data?.topUploader ? `${data.topUploader.name} (${data.topUploader.count})` : '—'}
                />
              </Card>
            </Col>
            <Col xs={12} sm={6}>
              <Card>
                <Statistic
                  title="Importo più alto"
                  value={data?.maxReceipt ? `€${data.maxReceipt.amount.toFixed(2)}` : '—'}
                />
                {data?.maxReceipt && (
                  <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                    {data.maxReceipt.name} · {dayjs(data.maxReceipt.date).format('DD/MM/YYYY')}
                  </Typography.Text>
                )}
              </Card>
            </Col>
            <Col xs={12} sm={6}>
              <Card><Statistic title="Media mensile" value={(data?.avgMonthly ?? 0).toFixed(2)} prefix="€" /></Card>
            </Col>
          </Row>

          <LineChartCard
            title="Importi scontrini per giorno"
            data={daily}
            xKey="date"
            series={[{ key: 'totalAmount', label: 'Importo (€)' }]}
          />
        </>
      )}
    </div>
  );
}
